import { Grid } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const CoachesGrid: FC<PropsWithChildren> = ({ children }) => (
  <Grid templateColumns="repeat(2, 1fr)" gap="4">
    {children}
  </Grid>
);
